import { UserAuditLogEntry } from 'apis/auditLogs';

import { LineItems } from './lineItems';
import { SummaryItems } from './summaryItems';
import { UserActivityCard } from './userActivityCard';
import {
  formatMoney,
  itemCountLabel,
  statusColors,
} from './userActivityTypes.utils';

type OrderCreatedProps = {
  entry: UserAuditLogEntry<'COMMERCE_ORDER_CREATED'>;
};

export const OrderCreated = ({ entry }: OrderCreatedProps): JSX.Element => (
  <UserActivityCard
    entry={entry}
    icon="credit-card"
    color={statusColors.positive}
    title="Order created"
    summary={
      <SummaryItems
        items={[
          { key: 'order', content: entry.order_id, copyText: entry.order_id },
          { key: 'total', content: formatMoney(entry.total) },
          { key: 'items', content: itemCountLabel(entry.line_items) },
        ]}
      />
    }
  >
    {entry.line_items?.length ? <LineItems items={entry.line_items} /> : null}
  </UserActivityCard>
);
